import classNames from 'classnames';

function getSessionId(session) {
  return session.chat_id || session.id;
}

function getSessionLabel(session) {
  return session.title || session.last_message || session.message || session.chat_id || session.id;
}

export function HarnessSessionList({
  currentChatId,
  hasMore,
  isLoading,
  onLoadMore,
  onNewChat,
  onSelectChat,
  sessions,
}) {
  return (
    <div className="rounded-lg border border-mystic-500 bg-white p-4">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-body-300">Sessions</h2>
        <button
          className="rounded-md bg-dodger-blue-500 px-3 py-2 text-sm font-semibold text-white transition hover:bg-dodger-blue-600"
          onClick={onNewChat}
          type="button"
        >
          New chat
        </button>
      </div>
      {isLoading ? <div className="text-sm text-body-300">Loading sessions…</div> : null}
      {!isLoading && sessions.length === 0 ? <div className="text-sm text-body-300">No chats yet.</div> : null}
      <div className="space-y-2">
        {sessions.map((session) => {
          const chatId = getSessionId(session);
          return (
            <button
              className={classNames(
                'block w-full rounded-md border px-3 py-2 text-left text-sm transition',
                currentChatId === chatId
                  ? 'border-dodger-blue-500 bg-dodger-blue-50 text-dodger-blue-700'
                  : 'border-mystic-500 text-body-500 hover:bg-solitude-500',
              )}
              key={chatId}
              onClick={() => onSelectChat(chatId)}
              type="button"
            >
              <div className="truncate font-semibold">{getSessionLabel(session)}</div>
              {chatId ? <div className="mt-1 truncate text-xs opacity-60">{chatId}</div> : null}
            </button>
          );
        })}
      </div>
      {hasMore ? (
        <button
          className="mt-3 w-full rounded-md border border-mystic-500 px-3 py-2 text-sm font-semibold text-body-500 transition hover:bg-solitude-500 disabled:cursor-not-allowed disabled:opacity-50"
          disabled={isLoading}
          onClick={onLoadMore}
          type="button"
        >
          {isLoading ? 'Loading…' : 'Load more'}
        </button>
      ) : null}
    </div>
  );
}
